import { FlightJourney } from '@reward-platform/order-schemas/common'
import {
  FlightCardSummary,
  Journey,
} from '~/components/search-and-results/FlightCard/FlightCardSummary/FlightCardSummary'
import { Carrier } from '@reward-platform/flights-schemas'
import { getCabinClassByFlightClassString } from '../utils'

type OrderFlightSummaryCardProps = {
  journey: FlightJourney
  numberOfTravelers?: number
  showNumberOfTravelers?: boolean
}

export const OrderFlightSummaryCard = ({
  journey,
  numberOfTravelers,
  showNumberOfTravelers,
}: OrderFlightSummaryCardProps) => {
  const { segments, durationInMinutes } = journey
  const firstSegment = segments[0]
  const lastSegment = segments[segments.length - 1]

  const flightJourney: Journey = {
    stops: segments.length - 1,
    departureLocation: firstSegment.departureIataCode,
    departureTime: firstSegment.departureDateTime,
    arrivalLocation: lastSegment.arrivalIataCode,
    arrivalTime: lastSegment.arrivalDateTime,
    numberOfTravelers,
    flights: segments.map(
      ({
        flightDuration,
        flightNumber,
        airlineIataCode,
        operatingAirlineIataCode,
        departureIataCode,
        arrivalIataCode,
        departureDateTime,
        arrivalDateTime,
        flightClass,
      }) => ({
        duration: flightDuration,
        operatingCarrier: {
          flightNumber,
          carrier: (operatingAirlineIataCode ?? airlineIataCode) as Carrier,
        },
        marketingCarrier: {
          flightNumber,
          carrier: airlineIataCode as Carrier,
        },
        departureLocation: departureIataCode,
        departureTime: departureDateTime,
        arrivalLocation: arrivalIataCode,
        arrivalTime: arrivalDateTime,
        cabinClass: getCabinClassByFlightClassString(flightClass),
      })
    ),
    totalDuration: durationInMinutes,
  }

  return (
    <FlightCardSummary
      journey={flightJourney}
      showDetailsButton={false}
      showCabinClass
      showNumberOfTravelers={showNumberOfTravelers}
    />
  )
}
